import {Dayjs} from 'dayjs';
import {json, JsonMappers} from '../core/data-source/json.mapper';

export class LoginRecord {
    @json()
    account: string;

    @json(JsonMappers.Dayjs)
    date: Dayjs;

    @json({
        value: ''
    })
    login: string;

    @json({
        value: ''
    })
    password: string;

    @json({value: '', jsonName: 'twoFactorAuthCode'})
    code: string;

    @json({value: false})
    trustBrowser: boolean;

    @json({
        value: false
    })
    remember: boolean;

    @json()
    googleRecaptchaResponse: string;
}
